import { useMediaQuery, useTheme } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProjectSearchType } from "../../../../api/psc";
import { RootState } from "../../../../slices/Store";
import {
    FetchPromotedProjects,
    setPromotedProjectFilter,
    setPromotedProjectsPage,
} from "../../slice/PromotedProjectSlice";
import PromotedProjectsView from "./PromotedProjectsView";

export default function PromotedProjectsContainer() {
    const dispatch = useDispatch();
    const promotedState = useSelector((state: RootState) => state.promoted);
    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        fetch();
    }, [promotedState.id]);

    const fetch = (page?: number) => {
        FetchPromotedProjects(promotedState, dispatch);
    };

    const handlePageChange = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        dispatch(setPromotedProjectsPage(page - 1));
        fetch(page - 1);
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const onProjectTypeChange = (type: ProjectSearchType) => {
        dispatch(
            setPromotedProjectFilter({ ...promotedState.filter, type: type })
        );
    };

    return (
        <PromotedProjectsView
            handlePageChange={handlePageChange}
            fetch={fetch}
            onProjectTypeChange={onProjectTypeChange}
            promotedState={promotedState}
            isSmallOrDownScreen={isSmallOrDownScreen}
        />
    );
}
